import { type CurrentUser, type UserType } from '@types';

export function getUserTypes (user: unknown): UserType[] {
  if (
    typeof user !== 'object' ||
    user === null ||
    !('type' in user) ||
    !Array.isArray((user as CurrentUser).type)
  ) {
    return [];
  }

  return (user as CurrentUser).type;
}
